import { SelectionValue } from "features/shared/types/select";
import { InfoAdapterType } from "features/shared/types/info";
import { Product } from "../types/product";
import { PropertyType } from "../types/subproduct";

export const initialFields: Product = {
    id: "",
    tags: [],
    tableIds: [],
    tables: {},
    properties: {
        type: InfoAdapterType.DefaultInfo,
    },
};

export const MINI_FORM_TABLE_FILE_UPLOAD_MODAL_SELECTION_OPTIONS: Array<
    SelectionValue<"link" | "file">
> = [
    {
        display: "Link / URL",
        value: "link",
    },
    {
        display: "File",
        value: "file",
    },
];

export const PROPERTY_TYPE_DISPLAY_MAP: Record<PropertyType, string> = {
    Text: "Text",
    FileDownload: "File / URL",
    Image: "Image",
    PromotionTags: "Promotion Tag",
};

export const PROPERTY_TYPE_SELECTION_OPTIONS: Array<
    SelectionValue<PropertyType>
> = Object.values(PropertyType).map((propertyType) => ({
    display: PROPERTY_TYPE_DISPLAY_MAP[propertyType],
    value: propertyType,
}));

export const initialTagSuggestions: string[] = [
    "category:",
    "process:",
    "supplier:",
    "application:",
    "custom:",
];
